// A page that reads a secret from its URL (a reset token, an invite token) takes it out of the
// address bar once it has it, so it does not sit in history, a shared screenshot or an analytics
// URL. The router keeps the location it started with, so the page still reads the secret.
import { useEffect } from 'react';

/** Replaces the address bar with `cleanPath` (no query, no token) on mount. Never throws. */
export function useClearUrlSecret(cleanPath: string) {
  useEffect(() => {
    try {
      if (window.location.pathname + window.location.search + window.location.hash !== cleanPath)
        window.history.replaceState(window.history.state, '', cleanPath);
    } catch {
      // An address bar we cannot touch is no reason to break the page.
    }
  }, [cleanPath]);
}
